<template>
  <div class="top">
    <div class="block">
      <el-form :inline="true">
        <el-form-item>
          <el-autocomplete style="margin-right:5px" placeholder="请输入交易对搜索" v-model="pair" :fetch-suggestions="querySearchAsync"  @change="findOne"/>
          <el-button type="primary" @click="getList({ page: 1 })">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="list">
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column label="交易对" prop="pair"></el-table-column>
        <el-table-column label="虚拟深度开关">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.enabledFlag" :active-value="1" :inactive-value="0" @change="changeFlag($event, scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="虚拟深度配置">
          <template slot-scope="scope">
            <el-button type="text" @click="toSet(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{scope.row.updateTime | moment}}
          </template>
        </el-table-column>
      </el-table>
      <pagination :page="pagination.page" :size="pagination.size" :total="total" @pageChanged="handleChange"></pagination>
    </div>
  </div>
</template>

<script>
import api from './api'
import {mapActions, mapState} from "vuex";
export default {
  name: "volumeQuery",
  data() {
    return {
      pair: '',
      list: [],
      pagination: {
        page: 1,
        size: 10
      },
      total: 0
    }
  },
  components: {
    Pagination: () => import('@/components/pagination')
  },
  computed: {
    ...mapState(['allSymbols'])
  },
  created() {
    this.$store.dispatch('getAllSymbols')
  },
  methods: {
    handleChange(val) {
      this.getList(val)
    },
    async getList(data = {}) {
      const { data: { list, totalCount } } = await api.getTradeVolume({
        ...this.pagination,
        ...data,
        pair: this.pair
      })
      this.list = list
      this.total = totalCount
    },
    querySearchAsync(queryString, cb) {
      let restaurants = this.allSymbols;
      let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      let suggest = [];
      for(let index in results) {
        suggest.push({'value':results[index].toUpperCase()});
      }
      cb(suggest);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    // 更新
    changeFlag(val, row) {
      api.editTradeVolume(row).then(res => {
        if (res.code === 0) {
          this.getList()
          this.$message({ message: '设置成功', type: 'success' })
        }
      })
    },
    findOne() {

    },
    toSet(row) {
      this.$parent.$parent.currentName = 'fifth'
      this.$store.commit('setActivePair', row)
    }
  }
}
</script>

<style scoped lang="less">
.block {
  padding: 40px 30px 10px 30px
}
</style>
